<template>
  <section
    v-if="!isSmallScreen"
    id="marquee-section"
    class="heading-1 sm:heading-1 flex w-full flex-col items-stretch justify-around gap-4 overflow-x-clip bg-[#] pb-60 leading-none text-[#f6f6f6]"
  >
    <!-- Marquee 1: Dynamic Direction -->
    <div class="marquee flex" role="marquee">
      <h4
        v-for="i in 3"
        :key="`marquee1-${i}`"
        class="flex items-center whitespace-nowrap text-nowrap font-bold"
      >
        Veja quem fez
        <div class="w-fit sm:mx-10 sm:scale-75">
          <svg
            style="width: var(--heading-display)"
            viewBox="0 0 55 37"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M36.2949 2.11614L35.9286 1.74986L35.4107 1.75L24.2607 1.753L21.2423 1.75381L23.3775 3.88724L32.4356 12.9381L11.7961 12.939H11.7959L3.00014 12.938L1.75 12.9379V14.188V22.991V24.241H3H32.4361L23.3764 33.2959L21.2405 35.4305L24.2602 35.43L35.4102 35.428L35.9278 35.4279L36.2938 35.0619L51.8838 19.4739L52.7678 18.5901L51.8839 17.7061L36.2949 2.11614Z"
              class="fill-current stroke-current stroke-[2.5]"
            />
          </svg>
        </div>
      </h4>
    </div>

    <!-- Marquee 2: Left to Right -->
    <div class="marquee flex" role="marquee">
      <h4
        v-for="i in 2"
        :key="`marquee2-${i}`"
        class="flex items-center whitespace-nowrap text-nowrap font-bold"
      >
        <!-- class="font-sans text-transparent [-webkit-text-stroke:1.5px_white]" -->
        Quem faz sucesso conosco
        <div class="w-fit fill-current sm:mx-10 sm:scale-75">
          <svg
            style="width: var(--heading-display)"
            viewBox="0 0 102 102"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M0.999042 53.5H1.00096L44.9238 53.5168L13.8776 84.5869L13.8762 84.5882L17.4118 88.1238L17.4131 88.1224L17.4149 88.1206L48.4832 57.0761L48.5 100.999V101.001H53.5V100.999L53.5168 57.0761L84.5869 88.1224L84.5882 88.1238L88.1238 84.5882L88.1224 84.5869L57.0761 53.5168L100.999 53.5H101.001V48.5H100.999L57.0761 48.4832L88.1206 17.4149L88.1224 17.4131L88.1238 17.4118L84.5882 13.8762L84.5869 13.8776L53.5168 44.9238L53.5 1.00096V0.999042H48.5V1.00096L48.4832 44.9238L17.4131 13.8776L17.4118 13.8762L13.8762 17.4118L13.8776 17.4131L44.9238 48.4832L1.00096 48.5H0.999042V53.5Z"
              class="fill-current stroke-current stroke-[2.5]"
            />
          </svg>
        </div>
      </h4>
    </div>

    <!-- Marquee 3: Right to Left -->
    <div class="marquee flex" role="marquee">
      <h4
        v-for="i in 3"
        :key="`marquee3-${i}`"
        class="flex items-center whitespace-nowrap text-nowrap font-bold"
      >
        Cases de sucesso
        <div class="w-fit fill-current sm:mx-10 sm:scale-75">
          <svg
            style="width: var(--heading-display)"
            viewBox="0 0 100 101"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M49.8234 1.99099C49.4293 9.09696 46.8886 17.4122 43.0707 24.0426C35.0272 38.01 21.1141 47.4665 5.21739 49.7899C4.1712 49.9394 2.55435 50.1024 1.65761 50.1567C0.747283 50.1975 0 50.279 0 50.3334C0 50.3877 0.747283 50.4692 1.65761 50.51C2.55435 50.5644 4.1712 50.7274 5.21739 50.8769C21.1141 53.2002 35.0272 62.6567 43.0707 76.6241C46.8886 83.2546 49.4293 91.5698 49.8234 98.6758C49.8641 99.5861 49.9457 100.333 50 100.333C50.0543 100.333 50.1359 99.5861 50.1766 98.6758C50.5707 91.5698 53.1114 83.2546 56.9293 76.6241C64.9728 62.6567 78.8859 53.2002 94.7826 50.8769C95.8288 50.7274 97.4456 50.5644 98.3424 50.51C99.2527 50.4692 100 50.3877 100 50.3334C100 50.279 99.2527 50.1975 98.3424 50.1567C97.4456 50.1024 95.8288 49.9394 94.7826 49.7899C78.8859 47.4665 64.9728 38.01 56.9293 24.0426C53.1114 17.4122 50.5707 9.09696 50.1766 1.99099C50.1359 1.08066 50.0543 0.333377 50 0.333377C49.9457 0.333377 49.8641 1.08066 49.8234 1.99099Z"
              class="fill-current"
            />
          </svg>
        </div>
      </h4>
    </div>

    <div
      role="marquee"
      ref="logos"
      class="logos-marquee mt-32 flex size-full gap-x-10"
    >
      <template v-for="i in 2" :key="i">
        <!-- Amazon -->
        <div role="marquee">
          <svg
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            viewBox="0 0 512 512"
            xml:space="preserve"
            fill="#000000"
          >
            <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
            <g
              id="SVGRepo_tracerCarrier"
              stroke-linecap="round"
              stroke-linejoin="round"
            ></g>
            <g id="SVGRepo_iconCarrier">
              <g id="7935ec95c421cee6d86eb22ecd1149e3">
                <path
                  style="
                    display: inline;
                    fill-rule: evenodd;
                    clip-rule: evenodd;
                    fill: #f6f6f6;
                  "
                  d="M293.596,233.97 c0,26.322,0.627,48.264-12.651,71.65c-10.724,19.022-27.791,30.698-46.749,30.698c-25.905,0-41.069-19.73-41.069-48.979 c0-57.525,51.607-67.983,100.469-67.983V233.97z M361.701,398.655c-4.48,4.005-10.934,4.283-15.971,1.567 c-22.446-18.64-26.462-27.263-38.718-45.009c-37.07,37.767-63.335,49.094-111.356,49.094c-56.871,0-101.09-35.085-101.09-105.269 c0-54.833,29.688-92.112,72.023-110.394c36.647-16.086,87.836-19.004,127.006-23.397v-8.774c0-16.074,1.253-35.091-8.218-48.979 c-8.217-12.43-24.013-17.542-37.905-17.542c-25.76,0-48.67,13.196-54.288,40.552c-1.178,6.094-5.612,12.11-11.745,12.425 l-65.459-7.092c-5.524-1.241-11.676-5.682-10.074-14.119c15.036-79.421,86.762-103.418,151.037-103.418 c32.857,0,75.823,8.774,101.729,33.63c32.857,30.71,29.7,71.65,29.7,116.248v105.223c0,31.65,13.138,45.543,25.487,62.615 c4.317,6.128,5.292,13.44-0.209,17.92c-13.8,11.571-38.324,32.869-51.811,44.87L361.701,398.655z M454.261,417.377 c-62.721,26.602-130.884,39.461-192.884,39.461c-91.933,0-180.924-25.209-252.882-67.096c-6.302-3.668-10.968,2.797-5.733,7.532 c66.702,60.236,154.845,96.425,252.732,96.425c69.846,0,150.949-21.971,206.903-63.254 C471.646,423.598,463.72,413.361,454.261,417.377z M470.962,467.655c-2.043,5.106,2.345,7.172,6.964,3.296 c30.014-25.116,37.767-77.716,31.615-85.317c-6.093-7.532-58.565-14.021-90.599,8.461c-4.921,3.481-4.062,8.24,1.394,7.59 c18.036-2.17,58.182-6.986,65.343,2.183C492.828,413.036,477.717,450.779,470.962,467.655z"
                ></path>
              </g>
            </g>
          </svg>
        </div>

        <!-- Shopee -->
        <div role="marquee">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            x="0px"
            y="0px"
            width="100"
            height="100"
            viewBox="0,0,256,256"
          >
            <g
              fill="#f6f6f6"
              fill-rule="nonzero"
              stroke="none"
              stroke-width="1"
              stroke-linecap="butt"
              stroke-linejoin="miter"
              stroke-miterlimit="10"
              stroke-dasharray=""
              stroke-dashoffset="0"
              font-family="none"
              font-weight="none"
              font-size="none"
              text-anchor="none"
              style="mix-blend-mode: normal"
            >
              <g transform="scale(5.12,5.12)">
                <path
                  d="M25,1c-5.32713,0 -9.39588,4.95314 -9.83398,11h-10.10742c-1.135,0 -2.05922,0.981 -1.99609,2.11328l1.72461,30.17188c0.14947,2.63699 2.34979,4.71484 4.99023,4.71484h30.44531c2.64119,0 4.84078,-2.07817 4.99023,-4.71484l1.72461,-30.16992c0.06514,-1.13309 -0.86109,-2.11523 -1.99609,-2.11523h-10.10742c-0.43811,-6.04686 -4.50685,-11 -9.83398,-11zM25,3c4.03694,0 7.40892,3.88679 7.83594,9h-15.67188c0.42701,-5.11321 3.799,-9 7.83594,-9zM25.08008,18c3.84,0 6.71898,2.06094 6.95898,2.21094l-1.0293,1.66992c-0.25,-0.17 -0.69914,-0.44102 -0.86914,-0.54102c-1.02,-0.55 -2.90055,-1.36914 -5.06055,-1.36914c-3.25,0 -5.59961,1.7993 -5.59961,4.2793c0,2.47 2.17976,3.44977 5.75977,4.75977c3.63,1.32 7.73047,2.81984 7.73047,7.58984c0,3.59 -3.54055,6.41016 -8.06055,6.41016c-3.99,0 -7.27008,-2.44961 -8.08008,-3.09961l1.10938,-1.65039c0.03,0.03 3.2207,2.76953 6.9707,2.76953c3.36,0 6.08984,-1.98969 6.08984,-4.42969c0,-3.16 -2.42945,-4.28023 -6.43945,-5.74023c-3.3,-1.21 -7.05078,-2.57937 -7.05078,-6.60937c0,-3.56 3.25031,-6.25 7.57031,-6.25z"
                ></path>
              </g>
            </g>
          </svg>
        </div>
        <!-- Spotify -->
        <div role="marquee">
          <svg
            viewBox="0 0 48 48"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            fill="#000000"
          >
            <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
            <g
              id="SVGRepo_tracerCarrier"
              stroke-linecap="round"
              stroke-linejoin="round"
            ></g>
            <g id="SVGRepo_iconCarrier">
              <title>Spotify-color</title>
              <desc>Created with Sketch.</desc>
              <defs></defs>
              <g
                id="Icons"
                stroke="none"
                stroke-width="1"
                fill="none"
                fill-rule="evenodd"
              >
                <g
                  id="Color-"
                  transform="translate(-200.000000, -460.000000)"
                  fill="#f6f6f6"
                >
                  <path
                    d="M238.16,481.36 C230.48,476.8 217.64,476.32 210.32,478.6 C209.12,478.96 207.92,478.24 207.56,477.16 C207.2,475.96 207.92,474.76 209,474.4 C217.52,471.88 231.56,472.36 240.44,477.64 C241.52,478.24 241.88,479.68 241.28,480.76 C240.68,481.6 239.24,481.96 238.16,481.36 M237.92,488.08 C237.32,488.92 236.24,489.28 235.4,488.68 C228.92,484.72 219.08,483.52 211.52,485.92 C210.56,486.16 209.48,485.68 209.24,484.72 C209,483.76 209.48,482.68 210.44,482.44 C219.2,479.8 230,481.12 237.44,485.68 C238.16,486.04 238.52,487.24 237.92,488.08 M235.04,494.68 C234.56,495.4 233.72,495.64 233,495.16 C227.36,491.68 220.28,490.96 211.88,492.88 C211.04,493.12 210.32,492.52 210.08,491.8 C209.84,490.96 210.44,490.24 211.16,490 C220.28,487.96 228.2,488.8 234.44,492.64 C235.28,493 235.4,493.96 235.04,494.68 M224,460 C210.8,460 200,470.8 200,484 C200,497.2 210.8,508 224,508 C237.2,508 248,497.2 248,484 C248,470.8 237.32,460 224,460"
                    id="Spotify"
                  ></path>
                </g>
              </g>
            </g>
          </svg>
        </div>

        <!-- gooogle -->
        <div role="marquee">
          <svg
            viewBox="0 0 20 20"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            fill="#000000"
          >
            <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
            <g
              id="SVGRepo_tracerCarrier"
              stroke-linecap="round"
              stroke-linejoin="round"
            ></g>
            <g id="SVGRepo_iconCarrier">
              <title>google [#f6f6f6178]</title>
              <desc>Created with Sketch.</desc>
              <defs></defs>
              <g
                id="Page-1"
                stroke="none"
                stroke-width="1"
                fill="none"
                fill-rule="evenodd"
              >
                <g
                  id="Dribbble-Light-Preview"
                  transform="translate(-300.000000, -7399.000000)"
                  fill="#f6f6f6"
                >
                  <g id="icons" transform="translate(56.000000, 160.000000)">
                    <path
                      d="M263.821537,7247.00386 L254.211298,7247.00386 C254.211298,7248.0033 254.211298,7250.00218 254.205172,7251.00161 L259.774046,7251.00161 C259.560644,7252.00105 258.804036,7253.40026 257.734984,7254.10487 C257.733963,7254.10387 257.732942,7254.11086 257.7309,7254.10986 C256.309581,7255.04834 254.43389,7255.26122 253.041161,7254.98137 C250.85813,7254.54762 249.130492,7252.96451 248.429023,7250.95364 C248.433107,7250.95064 248.43617,7250.92266 248.439233,7250.92066 C248.000176,7249.67336 248.000176,7248.0033 248.439233,7247.00386 L248.438212,7247.00386 C249.003881,7245.1669 250.783592,7243.49084 252.969687,7243.0321 C254.727956,7242.65931 256.71188,7243.06308 258.170978,7244.42831 C258.36498,7244.23842 260.856372,7241.80579 261.043226,7241.6079 C256.0584,7237.09344 248.076756,7238.68155 245.090149,7244.51127 L245.089128,7244.51127 C245.089128,7244.51127 245.090149,7244.51127 245.084023,7244.52226 L245.084023,7244.52226 C243.606545,7247.38565 243.667809,7250.75975 245.094233,7253.48622 C245.090149,7253.48921 245.087086,7253.49121 245.084023,7253.49421 C246.376687,7256.0028 248.729215,7257.92672 251.563684,7258.6593 C254.574796,7259.44886 258.406843,7258.90916 260.973794,7256.58747 C260.974815,7256.58847 260.975836,7256.58947 260.976857,7256.59047 C263.15172,7254.63157 264.505648,7251.29445 263.821537,7247.00386"
                      id="google-[#f6f6f6178]"
                    ></path>
                  </g>
                </g>
              </g>
            </g>
          </svg>
        </div>

        <!-- Microsoft -->
        <div role="marquee">
          <svg
            viewBox="-0.5 0 257 257"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            preserveAspectRatio="xMidYMid"
            fill="#000000"
          >
            <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
            <g
              id="SVGRepo_tracerCarrier"
              stroke-linecap="round"
              stroke-linejoin="round"
            ></g>
            <g id="SVGRepo_iconCarrier">
              <g>
                <path
                  d="M0,36.3573818 L104.619084,22.1093454 L104.664817,123.02292 L0.0955693151,123.618411 L0,36.3573818 Z M104.569248,134.650129 L104.650452,235.651651 L0.0812046021,221.274919 L0.0753414539,133.972642 L104.569248,134.650129 Z M117.25153,20.2454506 L255.967753,6.21724894e-15 L255.967753,121.739477 L117.25153,122.840723 L117.25153,20.2454506 Z M256,135.599959 L255.96746,256.791232 L117.251237,237.213007 L117.056874,135.373055 L256,135.599959 Z"
                  fill="#f6f6f6"
                ></path>
              </g>
            </g>
          </svg>
        </div>

        <!-- Apple -->
        <div role="marquee">
          <svg
            viewBox="-1.5 0 20 20"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            fill="#000000"
          >
            <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
            <g
              id="SVGRepo_tracerCarrier"
              stroke-linecap="round"
              stroke-linejoin="round"
            ></g>
            <g id="SVGRepo_iconCarrier">
              <title>apple [#f6f6f6173]</title>
              <desc>Created with Sketch.</desc>
              <defs></defs>
              <g
                id="Page-1"
                stroke="none"
                stroke-width="1"
                fill="none"
                fill-rule="evenodd"
              >
                <g
                  id="Dribbble-Light-Preview"
                  transform="translate(-102.000000, -7439.000000)"
                  fill="#f6f6f6"
                >
                  <g id="icons" transform="translate(56.000000, 160.000000)">
                    <path
                      d="M57.5708873,7282.19296 C58.2999598,7281.34797 58.7914012,7280.17098 58.6569121,7279 C57.6062792,7279.04 56.3352055,7279.67099 55.5818643,7280.51498 C54.905374,7281.26397 54.3148354,7282.46095 54.4735932,7283.60894 C55.6455696,7283.69593 56.8418148,7283.03894 57.5708873,7282.19296 M60.1989864,7289.62485 C60.2283111,7292.65181 62.9696641,7293.65879 63,7293.67179 C62.9777537,7293.74279 62.562152,7295.10677 61.5560117,7296.51675 C60.6853718,7297.73474 59.7823735,7298.94772 58.3596204,7298.97372 C56.9621472,7298.99872 56.5121648,7298.17973 54.9134635,7298.17973 C53.3157735,7298.17973 52.8162425,7298.94772 51.4935978,7298.99872 C50.1203933,7299.04772 49.0738052,7297.68074 48.197098,7296.46676 C46.4032359,7293.98379 45.0330649,7289.44985 46.8734421,7286.3899 C47.7875635,7284.87092 49.4206455,7283.90793 51.1942837,7283.88393 C52.5422083,7283.85893 53.8153044,7284.75292 54.6394294,7284.75292 C55.4635543,7284.75292 57.0106846,7283.67793 58.6366882,7283.83593 C59.3172232,7283.86293 61.2283842,7284.09893 62.4549652,7285.8199 C62.355868,7285.8789 60.1747177,7287.09489 60.1989864,7289.62485"
                      id="apple-[#f6f6f6173]"
                    ></path>
                  </g>
                </g>
              </g>
            </g>
          </svg>
        </div>

        <!-- Python 
        <div role="marquee">
          <svg viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg">
            <title>Python</title>
            <path
              d="M314,36.38c-18.59-3.06-45.8-4.47-64.27-4.38a311.09,311.09,0,0,0-51.66,4.38c-45.74,8-54.07,24.7-54.07,55.54V128H256v16H107.62C66.06,144,32.33,193.67,32,255.12c0,.29,0,.58,0,.88a162.91,162.91,0,0,0,3.13,32c9.29,46.28,38.23,80,72.49,80H128V314c0-31.3,20.84-59.95,55-66.1l9.87-1.23H314a56.05,56.05,0,0,0,15.06-2A52.48,52.48,0,0,0,368,193.68V91.92C368,63,343.32,41.19,314,36.38ZM194.93,105.5a20.37,20.37,0,1,1,20.3-20.3A20.29,20.29,0,0,1,194.93,105.5Z"
            />
            <path
              d="M475.28,217c-10.7-42.61-38.41-73-70.9-73H386.67v47.45c0,39.57-26,68.22-57.74,73.13a63.54,63.54,0,0,1-9.69.75H198.08a60,60,0,0,0-15.23,1.95C160.54,273.14,144,291.7,144,315.77V417.54c0,29,29.14,46,57.73,54.31,34.21,9.95,71.48,11.75,112.42,0,27.19-7.77,53.85-23.48,53.85-54.31V384H256V368H404.38c29.44,0,54.95-24.93,67.45-61.31A156.83,156.83,0,0,0,480,256,160.64,160.64,0,0,0,475.28,217ZM316.51,404a20.37,20.37,0,1,1-20.3,20.3A20.29,20.29,0,0,1,316.51,404Z"
            />
          </svg>
        </div>

        TypeScript
        <div role="marquee">
          <svg
            viewBox="0 0 14 14"
            aria-hidden="true"
            xmlns="http://www.w3.org/2000/svg"
          >
            <title>TypeScript</title>
            <path
              d="m 0.9999998,7.0000066 0,5.9999944 12.0000002,0 0,-12.00000195 -12.0000002,0 0,6.00000755 z m 7.359375,-0.2109464 0,0.5390661 -1.546875,0 0,4.9218757 -1.265625,0 0,-4.9218757 -1.5468751,0 0,-1.078119 4.3593751,0 0,0.5390529 z M 11.40625,6.3156206 c 0.192187,0.037467 0.407812,0.089067 0.482812,0.1171999 l 0.126563,0.0516 0,0.5859327 c 0,0.3234397 -0.0094,0.5859328 -0.01875,0.5859328 -0.0094,0 -0.107812,-0.0516 -0.220312,-0.1125332 -0.421875,-0.2390665 -1.096875,-0.328133 -1.509375,-0.2062532 -0.09844,0.028133 -0.24375,0.1171999 -0.31875,0.1921865 -0.1124998,0.1078666 -0.1359374,0.1734399 -0.1359374,0.3468797 0,0.1874932 0.023437,0.2390664 0.178125,0.384373 0.098437,0.093733 0.4640624,0.3093731 0.8203124,0.4875062 0.75,0.3703064 1.129687,0.6843726 1.303125,1.0734256 0.154687,0.3468794 0.159375,1.0781324 0.0094,1.4062524 -0.140625,0.309373 -0.45,0.623439 -0.754687,0.768759 -0.646875,0.30468 -1.7015627,0.332813 -2.5265627,0.06093 l -0.2953125,-0.0984 0,-1.303119 0.2343751,0.168747 c 0.3046604,0.220306 0.6984105,0.356253 1.1109105,0.384373 0.4124996,0.02813 0.7171876,-0.04693 0.9046876,-0.225 0.117188,-0.107866 0.140625,-0.168746 0.140625,-0.346879 0,-0.342187 -0.196875,-0.520307 -1.0031252,-0.9140529 C 9.2218738,9.371911 8.9968739,9.2125379 8.7859364,8.9031649 8.3171864,8.2234721 8.4578113,7.1828598 9.0859363,6.7094202 9.6203113,6.3016073 10.506249,6.1516074 11.406249,6.3156606 Z"
            />
          </svg>
        </div>

        Mysql
        <div role="marquee">
          <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <title>Mysql</title>
            <path
              d="m24.129 23.412-.508-.484c-.251-.331-.518-.624-.809-.891l-.005-.004q-.448-.407-.931-.774-.387-.266-1.064-.641c-.371-.167-.661-.46-.818-.824l-.004-.01-.048-.024c.212-.021.406-.06.592-.115l-.023.006.57-.157c.236-.074.509-.122.792-.133h.006c.298-.012.579-.06.847-.139l-.025.006q.194-.048.399-.109t.351-.109v-.169q-.145-.217-.351-.496c-.131-.178-.278-.333-.443-.468l-.005-.004q-.629-.556-1.303-1.076c-.396-.309-.845-.624-1.311-.916l-.068-.04c-.246-.162-.528-.312-.825-.435l-.034-.012q-.448-.182-.883-.399c-.097-.048-.21-.09-.327-.119l-.011-.002c-.117-.024-.217-.084-.29-.169l-.001-.001c-.138-.182-.259-.389-.355-.609l-.008-.02q-.145-.339-.314-.651-.363-.702-.702-1.427t-.651-1.452q-.217-.484-.399-.967c-.134-.354-.285-.657-.461-.942l.013.023c-.432-.736-.863-1.364-1.331-1.961l.028.038c-.463-.584-.943-1.106-1.459-1.59l-.008-.007c-.509-.478-1.057-.934-1.632-1.356l-.049-.035q-.896-.651-1.96-1.282c-.285-.168-.616-.305-.965-.393l-.026-.006-1.113-.278-.629-.048q-.314-.024-.629-.024c-.148-.078-.275-.171-.387-.279-.11-.105-.229-.204-.353-.295l-.01-.007c-.605-.353-1.308-.676-2.043-.93l-.085-.026c-.193-.113-.425-.179-.672-.179-.176 0-.345.034-.499.095l.009-.003c-.38.151-.67.458-.795.84l-.003.01c-.073.172-.115.371-.115.581 0 .368.13.705.347.968l-.002-.003q.544.725.834 1.14.217.291.448.605c.141.188.266.403.367.63l.008.021c.056.119.105.261.141.407l.003.016q.048.206.121.448.217.556.411 1.14c.141.425.297.785.478 1.128l-.019-.04q.145.266.291.52t.314.496c.065.098.147.179.241.242l.003.002c.099.072.164.185.169.313v.001c-.114.168-.191.369-.217.586l-.001.006c-.035.253-.085.478-.153.695l.008-.03c-.223.666-.351 1.434-.351 2.231 0 .258.013.512.04.763l-.003-.031c.06.958.349 1.838.812 2.6l-.014-.025c.197.295.408.552.641.787.168.188.412.306.684.306.152 0 .296-.037.422-.103l-.005.002c.35-.126.599-.446.617-.827v-.002c.048-.474.12-.898.219-1.312l-.013.067c.024-.063.038-.135.038-.211 0-.015-.001-.03-.002-.045v.002q-.012-.109.133-.206v.048q.145.339.302.677t.326.677c.295.449.608.841.952 1.202l-.003-.003c.345.372.721.706 1.127 1.001l.022.015c.212.162.398.337.566.528l.004.004c.158.186.347.339.56.454l.01.005v-.024h.048c-.039-.087-.102-.157-.18-.205l-.002-.001c-.079-.044-.147-.088-.211-.136l.005.003q-.217-.217-.448-.484t-.423-.508q-.508-.702-.969-1.467t-.871-1.555q-.194-.387-.375-.798t-.351-.798c-.049-.099-.083-.213-.096-.334v-.005c-.006-.115-.072-.214-.168-.265l-.002-.001c-.121.206-.255.384-.408.545l.001-.001c-.159.167-.289.364-.382.58l-.005.013c-.141.342-.244.739-.289 1.154l-.002.019q-.072.641-.145 1.318l-.048.024-.024.024c-.26-.053-.474-.219-.59-.443l-.002-.005q-.182-.351-.326-.69c-.248-.637-.402-1.374-.423-2.144v-.009c-.009-.122-.013-.265-.013-.408 0-.666.105-1.308.299-1.91l-.012.044q.072-.266.314-.896t.097-.871c-.05-.165-.143-.304-.265-.41l-.001-.001c-.122-.106-.233-.217-.335-.335l-.003-.004q-.169-.244-.326-.52t-.278-.544c-.165-.382-.334-.861-.474-1.353l-.022-.089c-.159-.565-.336-1.043-.546-1.503l.026.064c-.111-.252-.24-.47-.39-.669l.006.008q-.244-.326-.436-.617-.244-.314-.484-.605c-.163-.197-.308-.419-.426-.657l-.009-.02c-.048-.097-.09-.21-.119-.327l-.002-.011c-.011-.035-.017-.076-.017-.117 0-.082.024-.159.066-.223l-.001.002c.011-.056.037-.105.073-.145.039-.035.089-.061.143-.072h.002c.085-.055.188-.088.3-.088.084 0 .165.019.236.053l-.003-.001c.219.062.396.124.569.195l-.036-.013q.459.194.847.375c.298.142.552.292.792.459l-.018-.012q.194.121.387.266t.411.291h.339q.387 0 .822.037c.293.023.564.078.822.164l-.024-.007c.481.143.894.312 1.286.515l-.041-.019q.593.302 1.125.641c.589.367 1.098.743 1.577 1.154l-.017-.014c.5.428.954.867 1.38 1.331l.01.012c.416.454.813.947 1.176 1.464l.031.047c.334.472.671 1.018.974 1.584l.042.085c.081.154.163.343.234.536l.011.033q.097.278.217.57.266.605.57 1.221t.57 1.198l.532 1.161c.187.406.396.756.639 1.079l-.011-.015c.203.217.474.369.778.422l.008.001c.368.092.678.196.978.319l-.047-.017c.143.065.327.134.516.195l.04.011c.212.065.396.151.565.259l-.009-.005c.327.183.604.363.868.559l-.021-.015q.411.302.822.57.194.145.651.423t.484.52c-.114-.004-.249-.007-.384-.007-.492 0-.976.032-1.45.094l.056-.006c-.536.072-1.022.203-1.479.39l.04-.014c-.113.049-.248.094-.388.129l-.019.004c-.142.021-.252.135-.266.277v.001c.061.076.11.164.143.26l.002.006c.034.102.075.19.125.272l-.003-.006c.119.211.247.393.391.561l-.004-.005c.141.174.3.325.476.454l.007.005q.244.194.508.399c.161.126.343.25.532.362l.024.013c.284.174.614.34.958.479l.046.016c.374.15.695.324.993.531l-.016-.011q.291.169.58.375t.556.399c.073.072.137.152.191.239l.003.005c.091.104.217.175.36.193h.003v-.048c-.088-.067-.153-.16-.184-.267l-.001-.004c-.025-.102-.062-.191-.112-.273l.002.004zm-18.576-19.205q-.194 0-.363.012c-.115.008-.222.029-.323.063l.009-.003v.024h.048q.097.145.244.326t.266.351l.387.798.048-.024c.113-.082.2-.192.252-.321l.002-.005c.052-.139.082-.301.082-.469 0-.018 0-.036-.001-.054v.003c-.045-.044-.082-.096-.108-.154l-.001-.003-.081-.182c-.053-.084-.127-.15-.214-.192l-.003-.001c-.094-.045-.174-.102-.244-.169z"
            />
          </svg>
        </div> -->
      </template>
    </div>
  </section>
</template>

<script setup lang="ts">
  import gsap from 'gsap';
  import { ScrollToPlugin } from 'gsap/all';

  import { computed, onMounted, ref } from 'vue';
  import { useWindowSize } from '@vueuse/core';
  import { ScrollTrigger } from 'gsap/ScrollTrigger';

  // @ts-expect-error: No defs provided
  import { horizontalLoop } from './horizontal-loop.js';

  const { width } = useWindowSize();
  const isSmallScreen = computed(() => width.value < 640);
  const logos = ref<HTMLElement>(
    document.getElementById('logos') as HTMLElement,
  );

  // gsap.registerPlugin(Observer);
  gsap.registerPlugin(ScrollToPlugin);

  onMounted(() => {
    if (!isSmallScreen.value) {
      const marquees = gsap.utils.toArray('.marquee') as HTMLElement[];

      gsap.registerPlugin(ScrollTrigger);

      // Animate marquees
      marquees.forEach((marquee, index) => {
        gsap.set(marquee, {
          willChange: 'transform',
        });

        const tl = gsap.timeline({
          defaults: {
            ease: 'none',
          },
        });

        tl.fromTo(
          marquee,
          {
            x: -500 * ++index,
          },
          {
            x: 0,
            scrollTrigger: {
              trigger: '#marquee-section',
              start: 'top bottom',
              end: 'bottom top',
              scrub: 1,
              // markers: false,
            },
          },
        );
      });

      // Animate logos
      const logos = gsap.utils.toArray('.logos-marquee div');
      horizontalLoop(logos, {
        repeat: -1,
        paddingRight: 40,
        speed: 0.6,
      });
    }
  });
</script>

<style scoped>
  .logos-marquee div {
    @apply rounded-lg bg-[#DC91A6] transition-[background-color] duration-300 ease-in-out hover:bg-[#D45280];
  }

  .logos-marquee svg {
    width: var(--heading-1) !important;
    height: var(--heading-1) !important;
  }

  .logos-marquee div svg {
    @apply !m-10 !fill-flax-smoke-200;
  }
</style>
